exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-modal {\n  background: rgba(0, 0, 0, 0.25);\n  height: 100vw;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  z-index: 1000;\n}\n\n.filter-modal .filter-content {\n  background-color: #fff;\n  border-radius: 5px;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 5% auto 0;\n  padding: 18px;\n  width: 600px;\n}\n\n.filter-modal .filter-content .filter-title {\n  color: #333;\n  font-size: 24px;\n  margin-bottom: 20px;\n}\n\n.filter-modal .filter-title svg {\n  color: #bac2c7;\n  cursor: pointer;\n  float: right;\n}\n", ""]);

// exports
